package editor

import com.soywiz.korio.file.*

data class EditorFile(val file: VfsFile)
